module.exports = __webpack_public_path__ + "img/recharge.bf4a37ed.png";